<template>
  <van-cell title="最终签章文件">
    <ax-down
      v-for="(fileItem, index) in renderFile"
      type="ssc"
      :data="fileItem"
      :key="index"
    ></ax-down>
    <van-button
      v-if="!isSignFile"
      class="ess-sign-btn"
      type="primary"
      size="small"
      :loading="essSignLoading"
      loading-text="正在生成"
      loading-size="16"
      @click="handleEssSign"
      >确认生成</van-button
    >
  </van-cell>
</template>
<script>
import {
  getEsignpdfStatus,
  getEsignpdfDocuments,
  genSignFile
} from '@/api/oaLegalAffairs';
export default {
  name: 'FinalSignFileCom',
  props: {
    file: String,
    contractId: [String, Number]
  },
  data() {
    return {
      renderFile: [],
      isSignFile: false,
      essSignLoading: false
    };
  },
  mounted() {
    this.renderFile = this.file ? JSON.parse(this.file) : [];
    this.init();
  },
  methods: {
    async init() {
      if (this.renderFile.length > 0) return;
      try {
        const statusResponse = await getEsignpdfStatus(this.contractId);
        if (statusResponse.data.success) {
          await this.getDocuments();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async handleEssSign() {
      if (this.essSignLoading) return;
      this.essSignLoading = true;
      try {
        const signResponse = await genSignFile(this.contractId);
        if (signResponse.data.success) {
          await this.getDocuments();
          this.$toast.success('签章文件生成成功');
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.essSignLoading = false;
      }
    },
    async getDocuments() {
      const fileResponse = await getEsignpdfDocuments(this.contractId);
      if (fileResponse.data.success) {
        this.isSignFile = true;
        this.renderFile = fileResponse.data.data;
      }
    },
    getSignFile() {
      return this.isSignFile ? JSON.stringify(this.renderFile) : '';
    }
  }
};
</script>
<style lang="scss" scoped>
.ess-sign-btn {
  height: 28px;
  line-height: normal;
  vertical-align: middle;
}
</style>